import { makeObservable, observable, action, computed } from 'mobx';

type PrivateFields = '_message' | '_toastId';

export class ToastStore {
  private _message: string | null = null;
  private _toastId = 0;

  constructor() {
    makeObservable<ToastStore, PrivateFields>(this, {
      _message: observable,
      _toastId: observable,

      message: computed,
      toastId: computed,

      showError: action,
      clear: action
    });
  }

  get message(): string | null {
    return this._message;
  }

  get toastId(): number {
    return this._toastId;
  }

  showError = (message: string): void => {
    this._message = message;
    this._toastId++;
  };

  clear = (): void => {
    this._message = null;
  };
}
